import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { StatusSelectFieldComponent } from '../fields/status-select-field/status-select-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { TextareaFormFieldComponent } from '../fields/textarea-form-field/textarea-form-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { UsersService } from 'app/shared/services/users.service';
import { IUser } from 'app/shared/models/users.model';
import { Subject, take, takeUntil } from 'rxjs';
import { HelperService } from 'app/shared/services/helper.service';
import { CaseStatusEnum } from 'app/shared/enums/case-status.enum';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';

@Component({
  selector: 'app-problem-record-activity-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    SelectFormFieldComponent,
    StatusSelectFieldComponent,
    DatepickerFormFieldComponent,
    TextareaFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './problem-record-activity-form.component.html',
  styleUrl: './problem-record-activity-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class ProblemRecordActivityFormComponent {
  @Input() stageItems: any[] = [];
  @Input() problemRecordObject!: any;
  @Input() nextActionValidators!: boolean;
  @Input() problemStatus!: string;

  actionStatusItems: any = [];
  nextActionOwnerUsers: IUser[] = [];
  form: any;
  viewMode = true;
  today: Date = new Date();
  private destroy$ = new Subject<void>();

  constructor(
    public mainForm: FormGroupDirective,
    private configurationService: ConfigurationService,
    private usersService: UsersService,
    private helperService: HelperService
  ) { }

  ngOnChanges() {
    if (this.problemRecordObject) {
      this.getUsers();
    }
  }

  ngOnInit(): void {
    this.createForm();
    this.actionStatusItems = this.configurationService.getNextActionStatusItems();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('problemStage', new FormControl(null, []));
    this.form.addControl('nextActionStatus', new FormControl(null, []));
    this.form.addControl('nextActionOwnerId', new FormControl(null, []));
    this.form.addControl('nextActionDueDate', new FormControl(null, []));
    this.form.addControl('nextActionDescription', new FormControl(null, []));
  }

  getUsers() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.nextActionOwnerUsers = this.helperService.getUsersListWithSelectedUser(users, this.problemRecordObject.nextActionOwnerId, this.problemRecordObject.nextActionOwner);
    })
  }

  changeNextActionStatus(data: any) {
    if (this.problemStatus === CaseStatusEnum.VERIFY) {
      return;
    }

    if (data.statusValue) {
      this.form.get('problemStatus').setValue(data.statusValue);

      if (this.form && this.form.get('problemStatus')?.value === CaseStatusEnum.VERIFY) {
        this.form.get('verifyDate').setValue(new Date());
      } else {
        this.form.get('verifyDate').setValue(null);
      }
    }
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number) {
    this.usersService.getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...res];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...res];
        }
      });
  }

  getColorOfNextActionDueDate(nextActionDueDate: string): string {
    return this.helperService.getColorOfNextActionDueDate(nextActionDueDate);
  }

}
